<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>

    <div v-else>
      <!-- Alphabets -->
      <v-container fluid pa-0>
        <v-layout align-center row wrap>
          <v-flex
            text-xs-center
            :xs1="$vuetify.breakpoint.smAndDown"
            v-for="n in alphabets"
            :key="n"
          >
            <a href="#" @click="scrollTo('artist-alphabet-'+n)">{{ n }}</a>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- Artists listing -->
      <div
        v-for="(artists, i) in artistsMaster"
        :key="i"
        class="mt-4"
        :ref="'artist-alphabet-'+i"
        :id="'artist-alphabet-'+i"
      >
        <v-container fluid grid-list-xl>
          <v-layout align-center row wrap>
            <v-flex text-xs-center xs6 sm4 md3 lg2>
              <div class="display-3">{{ i }}</div>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2 v-for="artist in artists" :key="artist.id">
              <v-hover>
                <base-card
                  slot-scope="{ hover }"
                  color="secondary"
                  max-width="200px"
                  :class="{'elevation-12 scale-down' : hover}"
                  :to="{ name: 'artist.single', params: { artistSlug: artist.slug }}"
                >
                  <tk-media
                    height="180px"
                    sizes="200px"
                    :media="getArtistMedia(artist)"
                    :style="{'background-color': getArtistMedia(artist).color }"
                  >
                    <div class="text-xs-right">
                      <v-icon class="video-icon" v-if="artist.video" v-text="'fas fa-video'" />
                      <span v-if="artist.has_cv" class="v-icon cv">CV</span>
                    </div>
                  </tk-media>
                  <v-card-title class="pa-2">{{ artist.name }}</v-card-title>
                </base-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import { ErrorHandler } from "../../utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  name: "page-artsits",
  data() {
    return {
      loading: true,
      artistsMaster: {}
    };
  },

  computed: {
    alphabets() {
      return Object.keys(this.artistsMaster);
    }
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await handler.handle(async () => {
        // TODO Create separate Repository and Transformer
        // Hurryness leads to bad code
        const res = await this.$axios.get(`/artists?include=media`);
        this.artistsMaster = res.data["data"];
        console.log(this.artistsMaster);
      });
      this.loading = false;
    },
    scrollTo(elemId) {
      const elem = this.$refs[elemId][0];
      VueScrollTo.scrollTo(elem);
    },
    getArtistMedia(artist) {
      return {
        url: artist.media ? artist.media.url : "/static/img/user.png",
        color: artist.media ? artist.media.color : "",
        srcset: artist.media ? artist.media.srcset : ""
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.alphabet-container {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  .alphabet {
    float: none;
    display: table-cell;
    width: 1%;
    text-align: center;
    vertical-align: middle;
  }
}
.video-icon {
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  padding: 4px;
  border-bottom-left-radius: 2px;
  font-size: 1.2rem;
}

.cv {
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  padding: 4px;
  height: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
}
</style>

